import { FC } from 'react';
import { Spin } from 'antd';

export const WhatsappSettingsLoading: FC = () => {
  return <Spin />;
};
